export default function ProblemsSection() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2C2C]">
            こんなお悩み、ありませんか?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16 sm:mb-20">
          <div className="bg-gradient-to-br from-[#FAF0E6] to-[#F5F5DC] rounded-3xl p-8 sm:p-10 lg:p-12 shadow-lg">
            <div className="space-y-5 sm:space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-circle-line text-2xl text-[#E57373]"></i>
                </div>
                <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed">
                  パソコンが苦手なスタッフへ、教える時間がない
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-circle-line text-2xl text-[#E57373]"></i>
                </div>
                <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed">
                  SNSや公式LINEの更新が続かない
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-circle-line text-2xl text-[#E57373]"></i>
                </div>
                <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed">
                  Canvaで思い通りの画像が作れない
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-circle-line text-2xl text-[#E57373]"></i>
                </div>
                <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed">
                  ネットショップ更新が苦手で放置してしまう
                </p>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-close-circle-line text-2xl text-[#E57373]"></i>
                </div>
                <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed">
                  自分のペースで学べる相談相手がほしい
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-3xl p-8 sm:p-10 lg:p-12 shadow-xl">
            <div className="space-y-6 sm:space-y-8">
              <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2C2C2C] text-center">
                サポート内容
              </h3>
              
              <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
                <div className="flex-shrink-0">
                  <div className="w-64 h-64 sm:w-72 sm:h-72 rounded-2xl overflow-hidden shadow-lg">
                    <img 
                      alt="デジタルサポートのイメージ" 
                      className="w-full h-full object-cover object-top" 
                      src="https://public.readdy.ai/ai/img_res/151bea1f293681571cb82c5ff6651d29.jpg"
                    />
                  </div>
                </div>
                
                <div className="flex-1 space-y-4 sm:space-y-5 text-center lg:text-left">
                  <p className="text-base sm:text-lg lg:text-xl text-[#2C2C2C] leading-relaxed">
                    越谷・松伏を中心に、PC・Webが苦手なスタッフさんや<br />
                    お一人で学びたい方に寄り添うデジタルサポートです。
                  </p>
                  <p className="text-base sm:text-lg lg:text-xl text-[#2C2C2C] leading-relaxed">
                    <span className="font-bold text-[#66BB6A]">「急がなくてもいい」「わからないままにしない」</span>。
                  </p>
                  <p className="text-base sm:text-lg lg:text-xl text-[#2C2C2C] leading-relaxed">
                    そんな思いを大切に、SNSやHP更新、Canvaなど、<br />
                    日々の"困った"を安心して相談していただけます。
                  </p>
                  <p className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#2C2C2C] mt-6">
                    地元密着型web伴走支援
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}